// extracted by mini-css-extract-plugin
export default {"card":"Vote_card__JF4Li","striked":"Vote_striked__h4ZIk","entry":"Vote_entry__kTX1P","username":"Vote_username__M0v2M","tutorialWrapper":"Vote_tutorialWrapper__jYUZV"};